export function formatDecimalAmount(value: number, locale: string): string {
  if (value === null || value === undefined) {
    return "0";
  }

  if (Number.isInteger(value)) {
    return new Intl.NumberFormat(locale, {
      style: "decimal",
      maximumFractionDigits: 0,
    }).format(value);
  }

  return new Intl.NumberFormat(locale, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
